
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class QueryBuilderService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }



getAllViews(): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + 'reports/getreportviews').pipe(
          map((res: Response) => res),
          catchError((err: any) => observableThrowError(err.message || 'Server error')));
      }
getAllColumns(id: number,isMaintenance: boolean = false): Observable<any>{
    return this.httpClient.get(this.baseApiUrl + `reports/getcolumnname/${id}?isMaintenance=${isMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
   }


   getbalancemismatch(viewName: string): Observable<any> {
    // Using HttpParams to append viewName as a query parameter
    const params = new HttpParams().set('viewName', viewName);
  
    // Sending the viewName as part of the query string
    return this.httpClient.post(this.baseApiUrl + 'reports/getbalancemismatch', null, { params }).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }
//   public getbalancemismatch(viewName: String): Observable<any> {
//     return this.httpClient.post(this.baseApiUrl + `batch/getbalancemismatch?viewName=viewName`, {}).pipe(
//     map((res: Response) => res),
//     catchError((err: any) => observableThrowError(err.message || 'Server error')));
// }
}
